import React from 'react';
import { motion } from 'framer-motion';
export function PricingHero() {
  return <section className="bg-gray-950 px-4 pb-24 pt-16 text-center sm:px-6 lg:px-8 lg:pb-28 lg:pt-20" data-id="element-228" data-mp="2twv6e65pcfbd">
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto max-w-4xl" data-id="element-229" data-mp="2f8ijrzsi88tj">
        <h1 className="text-5xl font-extrabold leading-[0.95] tracking-tight text-white sm:text-6xl lg:text-7xl" data-id="element-230" data-mp="37wefb16c7uoq">
          Pick the plan that fits
          <span className="block text-red-500" data-id="element-231" data-mp="3cv7pokqbv5ko">your business.</span>
        </h1>
        <p className="mx-auto mt-8 max-w-2xl text-lg leading-relaxed text-gray-300 sm:text-xl" data-id="element-232" data-mp="2yvg706ov910c">
          Every plan is AdROI working as your marketing department — traffic in, conversions out.
          Upgrade any time.
        </p>
      </motion.div>
    </section>;
}